// extracted by mini-css-extract-plugin
export var box = "ContactBox-module--box--bf485";
export var centerAlign = "ContactBox-module--center--align--b0fd3";
export var content = "ContactBox-module--content--6ac39";
export var leftAlign = "ContactBox-module--left--align--11088";
export var rightAlign = "ContactBox-module--right--align--703d8";